<template>
  <div class="card text">
    <img
      :src="backgroundImage"
      class="card-img"
      style="max-height: 400px; object-fit: cover; opacity: 0.4"
    />
    <div class="card-img-overlay">
      <b-container>
        <h5 class="card-title text-center">
          어디서 코더스하이 강의를 만날 수 있는지 확인하세요.
        </h5>
        <b-row></b-row>
      </b-container>
    </div>
  </div>
  <!-- <b-container>
    <b-row>
      <b-col align="center">
        <h2 class="mb-5">어디서 코더스하이를 만날 수 있는지 확인하세요.</h2>
        <b-button variant="light" class="mr-5">강의 계획서</b-button>
        <b-button variant="primary">현재 진행중인 강의 확인하기</b-button>
      </b-col>
    </b-row>
  </b-container>-->
</template>

<script>
export default {
  data() {
    return {
      backgroundImage: require("@/assets/images/curriculumImages/curriculumFooterImage.jpg")
    };
  }
};
</script>

<style scoped></style>
